import { Box, Avatar, HStack, Text } from "@chakra-ui/react";
import Logo from "assets/logos/logo-sm.svg";
import { ReactComponent as NotificationsIcon } from "assets/svg/notifications.svg";
// assets
// import User from "assets/profile.svg";
import useWindowUrl from "hooks/useWindowUrl";
import React, { Component, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import { logger } from "util/logger";

export default function HashHeaderComponent(props) {
  const { store, dispatch } = useStore();
  const [pageUrl] = useWindowUrl();
  const history = useHistory();
  const timerRef = useRef();

  useEffect(() => {
    if (store && store?.isSignedIn && store.userData) {
      if (
        // !store?.userData?.patchFixForCountry||
        // !store?.userData?.phone
        // store.userData.patchFixForCountry === false ||
        store.userData.phone === null
      ) {
        localStorage.setItem("emailVerify2", store.userData?.email);
        timerRef.current = setTimeout(() => {
          history.push(
            `/phonenumber?email=${store.userData.email}&redirectUrl=${pageUrl}`
          );
        }, 1000);
        logger(store.userData.phone);
      }
    }

    return () => {
      timerRef.current && clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line
  }, [store?.userData]);

  return (
    <DashHeader
      {...props}
      store={store}
      userData={store?.userData || {}}
      dispatch={dispatch}
      history={history}
    />
  );
}

class DashHeader extends Component {
  state = {
    firstName: this?.props?.userData?.firstName,
    username: this.props?.userData?.username,
  };

  render() {
    return (
      <Box pos="relative" zIndex={999}>
        <section className="dash-header">
          <Box
            ml={[
              "0 !important",
              "0 !important",
              "0 !important",
              "242px !important",
            ]}
            w={[
              "100% !important",
              "100% !important",
              "100% !important",
              "calc(100% - 242px) !important",
            ]}
            minH="63px"
            className="dash-header-content"
          >
            <Box
              as={Link}
              to="/dashboard/home"
              visibility={[
                "visible !important",
                "visible !important",
                "visible !important",
                "hidden !important",
              ]}
            >
              <img src={Logo} alt="logo" />
            </Box>

            <HStack>
              <Link
                to="/dashboard/homenotifications"
                style={{ display: "flex" }}
              >
                <Box
                  boxSize="42px"
                  as={NotificationsIcon}
                  mr="8px !important"
                />
              </Link>

              <Link to="/dashboard/account" style={{ display: "flex" }}>
                <div className="dash-user-box">
                  {/* <img className="dash-user-img" src={User} alt="" /> */}
                  <Avatar
                    size="sm"
                    name={`${this.props?.userData?.firstName} ${this.props?.userData?.lastName}`}
                  />

                  <Text ml="6px !important">
                    {this.state.username || this.state.firstName}
                  </Text>
                </div>
              </Link>
            </HStack>
          </Box>
        </section>
      </Box>
    );
  }
}
